<div [@zoomInOnEnter] class="sessionCard mat-elevation-z2" role="region">
	<!--HEADER ROW-->
	<div class="headerRow">
		<label class="headerLabel">{{ session().title }}</label>
		@if (showActionMenu()) {
			<!--<sim-action-menu (onDelete)="confirmDelete()" [actions]="[{fontIcon: 'fa-edit', click: openEdit(), labelKey: T.BUTTON_EDIT}]" />-->
		}
	</div>
	<div class="headerRow">
		<span class="secondary">
			<mat-icon fontIcon="fa-images-user" fontSet="fas" inline />
			{{ session().type | enumLabel: EnumLabel.SessionType }}
		</span>
		<span class="secondary">
			<mat-icon fontIcon="fa-clock" fontSet="far" inline />
			{{ session().startTime | timeRangeLabel: session().plannedEndTime }}
		</span>
		<sim-session-status-tag [status]="session().state" />
	</div>

	<!--PANELS-->
	<section class="panels">
		@if (!stations().length && !participants().length) {
			<!--EMPTY STATE-->
			<div class="panel emptyState secondary">
				<mat-icon fontSet="fad" fontIcon="fa-layer-minus" />
				{{ T.PEER_PRACTICE_SESSION_CARD_RUNS_EMPTY_STATE | translate }}
			</div>
		} @else {
			<!--STATION GRID-->
			@if (stations().length) {
				<div class="panel" [class.small]="stations().length < 3">
					<label>
						<mat-icon fontIcon="fa-rectangles-mixed" fontSet="fas" inline />
						{{ T.LABEL_STATIONS | translate }}
					</label>
					<div class="itemGrid">
						@for (station of stations(); track station.id) {
							<sim-list-item
								[indicator]="station.index + 1"
								[primaryLabel]="station.room!.name"
								[secondaryLabel]="station.scenario!.name"
								[selectable]="false"
							/>
						}
					</div>
				</div>
			}

			<!--PARTICIPANT GRID-->
			@if (participants().length) {
				<div class="panel" [class.small]="participants().length < 3">
					<label>
						<mat-icon fontIcon="fa-users" fontSet="fas" inline />
						{{ T.LABEL_PARTICIPANTS | translate }}
					</label>
					<div class="itemGrid">
						@for (participant of participants(); track participant.id) {
							<sim-user-list-item [user]="participant" />
						}
					</div>
				</div>
			}
		}
	</section>

	<!--ACTION FOOTER-->
	<section class="actionsFooter">
		<ng-content select="[actions]" />
		@if (!disableControls()) {
			<!--ABORT SESSION-->
			@if (canCancelSession()) {
				<sim-button
					color="warn"
					(click)="cancelSession()"
					[appBusy]="abortPromise()"
					[icon]="{fontIcon: 'fa-stop', fontSet: 'fas'}"
					[label]="T.EVENT_SESSION_EXAM_SESSION_ABORT_SESSION_BTN_TXT"
					size="small"
				/>
			}
			<!--START SESSION-->
			@if (canStartSession()) {
				<div
					[matTooltip]="!isScheduledToday() ? (T.EVENT_SESSION_START_DISABLED_NOT_SAME_DAY | translate) : null"
					[matTooltipDisabled]="isScheduledToday()"
				>
					<sim-button
						(onClick)="startSession()"
						[label]="T.EVENT_SESSION_SESSION_START_BTN_TXT"
						[icon]="{fontSet: 'fas', fontIcon: 'fa-play-circle'}"
						[disabled]="!isScheduledToday()"
						[appBusy]="startPromise()"
						size="small"
						color="accent"
					/>
				</div>
			}
			<!--MC APP-->
			@if (canOpenMasterOfCeremony()) {
				<!-- AS MC -->
				<sim-button
					[icon]="{fontIcon: 'fa-user-crown', fontSet: 'fas'}"
					(click)="openMasterOfCeremonyApp('mc')"
					[hasPermission]="Permissions.EventPlanner_Create"
					[label]="T.EVENT_SESSION_EXAM_SESSION_OPEN_MASTER_OF_CEREMONY_APP_BTN_TXT_AS_MC"
					size="small"
				/>

				<!-- AS EXAMINER -->
				<sim-button
					(onClick)="openMasterOfCeremonyApp('examiner')"
					[icon]="{fontIcon: 'fa-user-md', fontSet: 'fas'}"
					[label]="T.EVENT_SESSION_EXAM_SESSION_OPEN_MASTER_OF_CEREMONY_APP_BTN_TXT_AS_EXAMINER"
					[disabled]="!canJoinAsExaminer()"
					[matTooltip]="examinerDisabledTooltip() ? (examinerDisabledTooltip()! | translate) : null"
					matTooltipClass="warn"
					size="small"
				/>
			}
		}
	</section>
</div>
